"use client";

import { FlexRow } from "@/components/flex-row";
import { Button } from "@/components/ui/button";

const uiText = {
  next: "Suivant",
  previous: "Précédent",
};

function StepNavigation({
  isNextButtonDisabled,
  isPreviousButtonDisabled,
  nextLabel = uiText.next,
  onNext,
  onPrevious,
  previousLabel = uiText.previous,
  showNextButton = true,
  showPreviousButton = true,
}: {
  isNextButtonDisabled?: boolean;
  isPreviousButtonDisabled?: boolean;
  nextLabel?: string;
  onNext: () => void;
  onPrevious: () => void;
  previousLabel?: string;
  showNextButton?: boolean;
  showPreviousButton?: boolean;
}) {
  return (
    <FlexRow className="w-full py-4">
      {showPreviousButton ? (
        <Button
          disabled={isPreviousButtonDisabled}
          onClick={onPrevious}
          type="button"
          variant="outline"
        >
          {previousLabel}
        </Button>
      ) : (
        <span />
      )}

      {showNextButton ? (
        <Button disabled={isNextButtonDisabled} onClick={onNext} type="button">
          {nextLabel}
        </Button>
      ) : null}
    </FlexRow>
  );
}

export { StepNavigation };
